import React, {useContext} from 'react'
import {RecipeUpdateContext} from "../../../../../context/RecipeUpdateContext";
import {Form, Input} from "antd";

const UpdateProductionCostName = ({id}) => {
    const {byId} = useContext(RecipeUpdateContext)
    const [recipeById, setRecipeById] = byId

    const handleNameChange = (value) => {
        let mockRows = Object.assign({}, recipeById)
        mockRows.recipeProductionCosts[id].costName = value
        setRecipeById(mockRows)
    }

    return(
        <React.Fragment>
            <Form
            >
                <Form.Item
                    name={'updateCostName'}
                    initialValue={recipeById.recipeProductionCosts[id].costName}
                >
                    <Input onChange={(event) => handleNameChange(event.target.value)} />
                </Form.Item>
            </Form>
        </React.Fragment>
    )
}
export default UpdateProductionCostName